<template lang="pug">
  .dialog-container(id="DialogPasteTags-container")
    el-row.row()
      el-col.col-left(:span="24")
        h4 {{ $t('Tags')}}:
        hr.header
        el-tag.tag-used(v-for='mediumTag in this.$store.state.Clipboard.copied_media_tags', :id="'DialogPasteTags-tag'+mediumTag.id",:key='mediumTag.id', :closable='false')
          span.tag-name {{ mediumTag.name }}
    el-row.row()
      el-col.col-middle(:span="24")
        el-button.confirm(id="DialogPasteTags-pasteButton" v-if='!saving', type="success", plain, @click="pasteTagsIntoMedia()", circle)
          | &nbsp; {{$t("Paste")}} &nbsp;
          font-awesome-icon.linker-icon(icon="tags")
        el-button.confirm.spinner(v-if='saving', type="primary", disabled, circle)
          font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
          .spinner-text {{ percentDone }}%
    el-row.row()
      el-col.col-left(:span="24")
        h4 {{$t('Media selected')}}:
        hr.header
        ShortMediaList(id="DialogPasteTags-mediaList" ref='pasteTagsMediaList', :items='this.$store.state.Medium.media_selected_left', :showThumbs="true", :showMediaIcons="true")
</template>

<script>

import ShortMediaList from '../Common/ShortMediaList'

export default {
  props: [],
  components: {
    ShortMediaList
  },
  created () {
  },
  data () {
    return {
      errors: {
      },
      saving: false,
      percentDone: 0
    }
  },
  methods: {
    async pasteTagsIntoMedia () {
      this.$emit('linkerJobStarted')
      this.saving = true
      const toBeDoneOperations = this.$refs.pasteTagsMediaList.selectedItems.length * this.$store.state.Clipboard.copied_media_tags.length
      let doneSoFarOperations = 0
      try {
        for (const mediumToPasteTags of this.$refs.pasteTagsMediaList.selectedItems) {
          for (const tag of this.$store.state.Clipboard.copied_media_tags) {
            await this.$store.dispatch('Medium/addMediumTagToMedium', [tag.id, mediumToPasteTags.id])
            doneSoFarOperations++
            this.percentDone = parseInt(doneSoFarOperations / toBeDoneOperations * 100)
          }
        }
      } catch (error) {
        this.$store.dispatch('Medium/clearMediaSelectedLeft')
      } finally {
        this.$store.dispatch('Medium/clearMediaSelectedLeft')
        this.$store.dispatch('Medium/getMediaList')
        this.$store.dispatch('Medium/analyzeList')
        this.$emit('linkerJobDone')
        this.saving = false
        this.percentDone = 0
      }
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "./dialog.scss";
.tag-used {
  min-width: 50px;
  margin: 0px 3px;
  text-align: center;
}
.confirm {
  &.spinner {
    .spinner-icon {
      font-size: 40px;
      margin-top: -5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Linker/DialogPasteTags.vue